import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import App from './App';
import Registration from './pages/Registration';
import { T } from '@testout/labsim-ui-atomics';
import { I18nProvider } from './i18n/i18nProvider';
function AppRouter() {
    return (React.createElement(BrowserRouter, null,
        React.createElement(Switch, null,
            React.createElement(Route, { path: '/register/:inviteid', component: Registration }),
            React.createElement(Route, { path: '*', component: App }))));
}
export default function AppRouterWithContexts() {
    return (React.createElement(I18nProvider, null,
        React.createElement(T.Automation.IsAutomationFromURL, null,
            React.createElement(AppRouter, null))));
}
//# sourceMappingURL=AppRouter.js.map